/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of trackervalues (patients) to display or load trackervalues */


(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackervaluelist', {
      restrict: 'E',
      bindings: {
        clientid: '<',
        trackerid: '<'
      },
      template: `
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Datum</th>
            <th>Wert(e)</th>
            <th>Aktion</th>
          </tr> 
          </thead>
          <tr ng-repeat="trackervalue in vm.trackervalues">
            <td>{{trackervalue.dateat}}</td>
            <td>
                <div ng-repeat="def in trackervalue.def">
                    <span class="pull-left">{{def.label}}</span>
                    <span class="pull-right" style="text-align: right">{{def.value}} {{def.unit}}</span>
                    <span class="clearfix"></span>
                </div>
            </td>
            <td>
              <button class="btn btn-primary btn-xs" ng-click="vm.editTrackervalue(trackervalue)" uib-tooltip="Editieren"><i class="fa fa-edit"></i></button>
              <button class="btn btn-danger btn-xs" ng-click="vm.removeTrackervalue(trackervalue)" uib-tooltip="Löschen"><i class="fa fa-remove"></i></button>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Trackervalue', 'TrackervalueHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Trackervalue, TrackervalueHelper, vertxEventBusService) {
          let vm = this;
          vm.editTrackervalue = TrackervalueHelper.editTrackervalue;
          vm.removeTrackervalue = removeTrackervalue;
          
          vm.$onInit = function () {
            if (angular.isDefined(vm.trackerid && vm.trackerid.length > 0)) {
              vm.trackervalues = Trackervalue.$search({trackerid: vm.trackerid, active: true, patientid: vm.clientid});
            }
          }; // $onInit()

          // trackerid migth be late propagating
/*          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.trackerid) &&
                angular.isDefined(changes.trackerid.currentValue) &&
              changes.trackerid.currentValue.length > 0) {
              vm.trackerid = changes.trackerid.currentValue;
              vm.trackervalues = Trackervalue.$search({trackerid: vm.trackerid});
            }
          }; // $onChanges()*/
          
          
          function removeTrackervalue(trackervalue) {
            $log.debug('tracker value list remove: ', trackervalue);
            trackervalue.active = false;
            trackervalue.$save();
          }
          
          vertxEventBusService.on('trackervalues.update', function (message) {
            $log.debug('debug: trackervalue update received in trackervaluelist: ', message);
            let messages = message.split(':');
            vm.trackervalues.$refresh().$then(function () {
              $log.debug('debug: trackervaluelist refreshed trackervalues');
            }, function (error) {
              $log.debug('debug: trackervaluelist refresh trackervalues failed: ', error);
            });
          });
          
          
          
          
        }] // controller
    }); // component
  
  // klammerfriedhof
}());